import { Component, inject } from '@angular/core';

import {AuthService} from './_services/auth.service';

import { RouterLink } from '@angular/router';


@Component({
    selector: 'app-login', templateUrl: 'login.component.html',
    imports: [RouterLink]
})
export class LoginComponent {
    authService = inject(AuthService);
}
